import { Flex, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { FieldGroupBox, RuleStack, Tag, useDrawerState } from 'ui'
import { BuyAndWinTrigger } from '../../../../../../typings'
import { ItemsView } from '../../../../../ItemsView'
import { SCOPE_OPTIONS } from '../../../../../ItemsView/typing'
import styles from '../../styles'
import { BuyAndWinTriggerEditor } from '../Editor'
import { messages } from '../messages'
import { EmptyTrigger } from './Empty'

const EMPTY_CONFIG: NonNullable<BuyAndWinTrigger> = {
  collections: [],
  minQuantity: 1,
  skus: [],
  sameItemsOnly: false,
}

type BuyAndWinTriggerViewProps = {
  name: string
  config: BuyAndWinTrigger | undefined
  onChange: (config: BuyAndWinTrigger | undefined) => void
}

export function BuyAndWinTriggerView(props: BuyAndWinTriggerViewProps) {
  const { config, name, onChange } = props
  const { $t } = useIntl()

  const drawerState = useDrawerState()

  const handleRemove = (type: SCOPE_OPTIONS) => {
    if (!config) return

    let newConfig: BuyAndWinTrigger | undefined = { ...config, [type]: [] }

    if (!newConfig.collections.length && !newConfig.skus.length)
      newConfig = undefined

    onChange(newConfig)
  }

  const showEqualsMessage = config?.sameItemsOnly && config.minQuantity > 1

  return (
    <div>
      {config ? (
        <Flex direction="column" className={styles.view.content}>
          <Text>
            {$t(
              showEqualsMessage
                ? { ...messages.descriptionEquals }
                : { ...messages.description },
              {
                tag: (content) => (
                  <Tag className={styles.view.content}>{content}</Tag>
                ),
                min: config.minQuantity,
              }
            )}
          </Text>
          <FieldGroupBox name={name} withBorder={false}>
            <RuleStack>
              <ItemsView
                config={config}
                onEdit={drawerState.show}
                onRemove={handleRemove}
              />
            </RuleStack>
          </FieldGroupBox>
        </Flex>
      ) : (
        <EmptyTrigger onAdd={drawerState.show} name={name} />
      )}

      <BuyAndWinTriggerEditor
        state={drawerState}
        initialConfig={config ?? EMPTY_CONFIG}
        onSave={(newSettings) => onChange(newSettings)}
      />
    </div>
  )
}
